import SolutionsHero from '../sections/SolutionsHero'
import SolutionsProblem from '../sections/SolutionsProblem'
import SolutionsApproach from '../sections/SolutionsApproach'
import SolutionsWhoFor from '../sections/SolutionsWhoFor'
import SolutionsCTA from '../sections/SolutionsCTA'
import Footer from '../sections/Footer'

const SolutionsPage = () => {
  return (
    <>
      <SolutionsHero />
      <SolutionsProblem />
      <SolutionsApproach />
      <SolutionsWhoFor />
      <SolutionsCTA />
      <Footer />
    </>
  )
}

export default SolutionsPage
